module.exports = __webpack_public_path__ + "img/being-creative.ec02eae4.svg";